<!-- 考证辅导 -->
<template>
  <div class="el-Coach">
    <el-row class="content_block mb30">
      <TitleInfo title="考证辅导" :titleImg="fudao"></TitleInfo>
      <el-row class="pt30 pl30 coach_list">
        <ul>
          <template v-for="(item, index) in myAppsList" >
            <li :key="index">
              <span class="num_coach">{{index + 1}}</span>
              <el-row>
                <p class="title_coach limit_line_one fontB">{{item.courseInfoName}}</p>
              </el-row>
              <el-row class="tc mt50 mb30">
                <i class="el-icon-video-play c_p" style="font-size: 45px;color: #2789E2;" @click="coachExamList(item,index)"></i>
              </el-row>
              <el-row>
                <el-col :span="12" class="tc">
                  <i class="el-icon-circle-close c_p" style="font-size: 30px;color: #00BDCE;" @click="errorSet(item)"></i>
                  <br>
                  <el-link style="margin-top: 10px;" @click="errorSet(item)" :underline="false">我的错题</el-link>
                </el-col>
                <el-col :span="12" class="tc">
                <i class="el-icon-star-off c_p" style="font-size: 30px;color: #395FEC;" @click="Exercises(item)"></i>
                  <br>
                  <el-link style="margin-top: 10px;" @click="Exercises(item)" :underline="false">我的收藏</el-link>
                </el-col>
              </el-row>
            </li>
          </template>
        </ul>
        <el-empty v-if="myAppsList.length <= 0" description=""></el-empty>
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[6, 12, 20, 40]"
        :page-size="limit"
        background
        class="m20 t_r"
        :hide-on-single-page="true"
        layout="sizes, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "Coach",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      fudao:require("../../images/coach/fudao@2x.png"),
      myAppsList:[],
      total: 0,
      limit:6,
      page:1,
      timeIn:null
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
    //this.addSystem();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        courseInfoStatus:1,
        courseInfoType: 1,
        courseLabelTypes:'考证课程类'
      }
      this.$post("/api/courseInfo/getKzPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.myAppsList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    coachExamList(item){ //考证list
      this.$ls.set(this.$getKeyInfo("logName"),item.courseInfoName); //用于使用记录
      this.$router.push({name:'CoachExamList',query:{courseId:item.courseInfoId,courseInfoName:item.courseInfoName}});
    },
    errorSet(item){ //我的错题
      this.$ls.set(this.$getKeyInfo("logName"),item.courseInfoName); //用于使用记录
      this.$router.push({name:'CoachErrorSet',query:{courseId:item.courseInfoId,tuckOrError:"ERROR_TEST",courseInfoName:item.courseInfoName}});
    },
    Exercises(item){ //我的收藏
      this.$ls.set(this.$getKeyInfo("logName"),item.courseInfoName); //用于使用记录
      this.$router.push({name:'CoachFavorites',query:{courseId:item.courseInfoId,tuckOrError:"TUCK_TEST",courseInfoName:item.courseInfoName}});
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"考证辅导",//一级名称
          secondName:"考证辅导",//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-Coach{
    padding: 20px 20px 0;
    .coach_list{
      min-height: 320px;overflow: auto;
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        float: left;
        width: 260px;
        height: 220px;
        padding: 20px;
        margin: 0 30px 30px 0;
        border: 1px solid #E1E1E1;
        background-image: url("../../images/course/num_bg@2x.png");
        background-size: 50px;
        background-repeat:no-repeat;
        position: relative;
      }
      .num_coach{
        position: absolute;top: 10px;left: 10px;color: #2789E2;
      }
      .title_coach{
        margin: 0;
        margin-left: 20px;float: left;
        width: calc(100% - 10px);
      }
      .coach_img{
        width: 25px;
        height: 25px;
      }
    }

    .content_block{
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .thirdParty_img{
      width: 310px;
      height: 176px;
      float: left;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/certificate/Coach.vue